/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

exports.onClientEntry = () => {
  console.log('onClientEntry redirect to https://careers.reece.com/anz');
  window.location.href = 'https://careers.reece.com/anz';
};

exports.onRouteUpdate = ({ location, prevLocation }) => {
  console.log('onRouteUpdate redirect to https://careers.reece.com/anz');
  window.location.href = 'https://careers.reece.com/anz';
};
